import { render } from "./IssueCardAdd.vue?vue&type=template&id=74792996&scoped=true"
import script from "./IssueCardAdd.vue?vue&type=script&lang=js"
export * from "./IssueCardAdd.vue?vue&type=script&lang=js"

import "./IssueCardAdd.vue?vue&type=style&index=0&id=74792996&lang=scss&scoped=true"
import "./IssueCardAdd.vue?vue&type=style&index=1&id=74792996&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74792996"]])

export default __exports__